import { Breakpoint, BreakpointsOptions } from '@mildang/mui';

const unit: BreakpointsOptions['unit'] = 'px';

const step: BreakpointsOptions['step'] = 5;

const values: Record<Breakpoint, number> = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
};

export const breakpointKeys = Object.keys(values);

export const breakpoints: BreakpointsOptions = {
  values,
  step,
  unit,
};
